<template>
<!-- Wo im Ablauf man steht, als Kachelreihe (Warteschlange aus der
     Layoutskizze D): erledigt hell mit Haken, aktuell dunkel, offen leer.
     Der Text ist fuer alle da, die Kacheln nur fuers Auge. Erst ab zwei
     Schritten, bei einem gibt es nichts zu zeigen. -->
<div v-if="anzahl > 1" class="stepper">
    <p class="stepper__text">{{ wort }} {{ Math.min(aktuell + 1, anzahl) }} von {{ anzahl }}</p>
    <ol class="stepper__kacheln" aria-hidden="true">
        <li v-if="anfang > 0" class="mehr">+{{ anfang }}</li>
        <li v-for="n in sichtbar" :key="n"
            :class="{ erledigt: n - 1 < aktuell, aktuell: n - 1 === aktuell }">{{ n }}</li>
        <li v-if="anzahl - ende > 0" class="mehr">+{{ anzahl - ende }}</li>
    </ol>
</div>
</template>

<script>
import { computed } from 'vue'

// Hoechstens so viele Kacheln; bei mehr ein Ausschnitt um die aktuelle.
const HOECHSTENS = 10

export default {
    props: {
        anzahl: {type: Number, required: true},
        // Index des laufenden Schritts, ab 0. Gleich anzahl = alle erledigt.
        aktuell: {type: Number, required: true},
        wort: {type: String, default: 'Spruch'}
    },
    setup(props) {
        const anfang = computed(() => Math.max(0, Math.min(props.aktuell - 3, props.anzahl - HOECHSTENS)))
        const ende = computed(() => Math.min(props.anzahl, anfang.value + HOECHSTENS))
        // Nummern der sichtbaren Kacheln, ab 1.
        const sichtbar = computed(() => Array.from({ length: ende.value - anfang.value }, (_, i) => anfang.value + i + 1))
        return { anfang, ende, sichtbar }
    }
}
</script>

<style scoped>
.stepper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem 1rem;
    margin: 0 0 1.25rem;
}

.stepper__text {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 650;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--zs-grau);
}

.stepper__kacheln {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem;
    margin: 0;
    padding: 0;
    list-style: none;
}

.stepper__kacheln li {
    display: grid;
    place-items: center;
    min-width: 2.25rem;
    height: 1.75rem;
    padding: 0 0.4rem;
    font-size: 0.8rem;
    font-weight: 650;
    color: var(--zs-grau);
    background: var(--zs-flaeche);
    border: 1px solid var(--zs-rahmen);
    border-radius: 6px;
    box-sizing: border-box;
}

.stepper__kacheln li.erledigt {
    color: var(--zs-oliv);
    background: var(--zs-oliv-hell);
    border-color: transparent;
}

.stepper__kacheln li.erledigt::before {
    content: '\2713\00a0';
}

.stepper__kacheln li.aktuell {
    color: #ffffff;
    background: var(--zs-tinte);
    border-color: var(--zs-tinte);
}

.stepper__kacheln li.mehr {
    min-width: auto;
    color: var(--zs-grau);
    background: transparent;
    border: none;
}
</style>
